module.exports = __webpack_public_path__ + "static/favicon-test-60aec60063662b312639a8d3f109a17e.png";